var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"100vh","padding-top":"50px"},attrs:{"width":"100%","src":_vm.ApiUrl + '/pdfjs/web/viewer.html?file=' + _vm.modalTraceData.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }